import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/auth.service';
import { SettingsService } from '../services/settings.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private settingsService: SettingsService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    // Permitir paso si viene un token en la URL (AppComponent lo procesará)
    if (route.queryParams['token']) {
      return true;
    }

    const token = this.authenticationService.getAccessToken();
    if (token) {
      return true;
    }

    // Sin token, redirigir al login externo
    window.location.href = this.settingsService.LOGIN_URL;
    return false;
  }
}
